import * as React from 'react';
import { GridDayProps } from '../../components/grid/day';

import moment from 'moment';
import GridEventView from '../../components/grid/event';

const GridDayView: React.StatelessComponent<GridDayProps> = props => {
    let dateMoment = moment(props.day.date) as any;
    let now = moment().toDate();
    const isToday = moment().format("MMM Do YY") == dateMoment.format("MMM Do YY") ? "ace-cal-grid-day-today" : "";

    return (
        <li className={`ace-cal-grid-day ${isToday} ${props.day.events.length > 0 ? "ace-cal-grid-day-has-events" : ""}`} aria-labelledby={`Day-${dateMoment.format("X")}`}>
            {
                props.day.events.length > 0 ?
                    <div className="ace-cal-grid-day-wrapper">
                        <article className="ace-cal-grid-day-content">
                            <span aria-hidden="true" role="presentation" className="ace-cal-grid-day-date">{dateMoment.format("D")}</span>
                            <h4 id={`Day-${dateMoment.format("X")}`} className="visually-hidden">
                                {
                                    <span role="text">
                                        {`${dateMoment.format("dddd, MMMM")} ${dateMoment.format("D")}`}
                                        <span>{`: ${props.day.events.length} ${props.day.events.length > 2 ? props.text.pluralEventsText : props.text.singleEventText}`}</span>
                                    </span>
                                }
                            </h4>
                           
                            <ul className="ace-cal-grid-day-content">
                                {props.day.events.map(event => {
                                    var isEventSameDay = dateMoment.format("MMM Do YY") == moment(event.eventDate).format("MMM Do YY")
                                    return (
                                        isEventSameDay ?
                                        <GridEventView key={event.id} event={event} />
                                        : null);
                                })}
                            </ul>
                 

                        </article>
                    </div>
                    :
                    <div className="ace-cal-grid-day-wrapper">
                        <div className="ace-cal-grid-day-content">
                            <span className="ace-cal-grid-day-date" id={`Day-${dateMoment.format("X")}`} role="text"><span className="visually-hidden">{`${dateMoment.format("dddd, MMMM")} `}</span>{dateMoment.format("D")}</span>
                        </div>
                      
                    </div>
            }

        </li>
    );
}

export default GridDayView;